import { render, staticRenderFns } from "./register3.vue?vue&type=template&id=5456eff0&scoped=true&"
import script from "./register3.vue?vue&type=script&lang=js&"
export * from "./register3.vue?vue&type=script&lang=js&"
import style0 from "./register3.vue?vue&type=style&index=0&id=5456eff0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456eff0",
  null
  
)

export default component.exports